import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  getSurveysFromAPI,
  addSurveyFromAPI,
  deleteSurveyFromAPI,
} from "../../../services/surveyService";
import {
  setSurveys,
  setCurrentSurvey,
  setSurveyDetailSelectedTab,
  updateTabPath,
  updateTabStates,
} from "../../../store/actions";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useTheme } from "@aws-amplify/ui-react";
export default function LeftMenuSurveys({expanded,getLeftMenuExpandActionFromChild}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => state.themeMode);
  const surveys = useSelector((state) => state.surveys);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  // const surveys = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.surveys;

  let [token, setToken] = useState("");
  let [selectedFunction, setSelectedFunction] = useState("");
  let [selectedFunctionParam, setSelectedFunctionParam] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [selectedSurveyId, setSelectedSurveyId] = useState(null);
  const [deleteAllowMenuOpen, setDeleteAllowMenuOpen] = useState(false);
  const [deleteInfoMenuShow, setDeleteInfoMenuShow] = useState(false);
  const [cloneInfoMenuShow, setCloneInfoMenuShow] = useState(false);
  const [selectedFilterItems, setSelectedFilterItems] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [surveyStatus, setSurveyStatus] = useState([
    {
      title: "Draft",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#A1A1A1"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
          ></path>
        </svg>
      ),
      checked: false,
    },
    {
      title: "In Progress",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#5195D7"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
          ></path>
          <path
            d="M 4.5 4.5 L 9 4.5 A 4.5 4.5 0 1 1 0.00022499812500598182 4.54499925000375 Z"
            transform="translate(3.5,3.5)"
          ></path>
        </svg>
      ),
      checked: false,
    },
    {
      title: "Completed",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#83AF12"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C15,4.1,11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path>
          <path d="M10.6,6.1L7.5,9.2L5.9,7.6c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l2,2c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l3.5-3.5c0.2-0.2,0.2-0.6,0-0.8S10.8,5.8,10.6,6.1z"></path>
        </svg>
      ),
      checked: false,
    },
  ]);
  const [clearFilter, setClearFilter] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const sortOptions = [{ name: "Status", href: "#", current: true }];
  
  const handleStatusClick = (status) => {
    // const updatedStatus = [...surveyStatus];
    // updatedStatus[index].checked = !updatedStatus[index].checked; // Tıklanan status'un checked değerini değiştir
    // setSurveyStatus(updatedStatus); // Güncellenmiş statusları state'e set et
    const updatedStatus = surveyStatus.map((item) => {
      if (item.title === status.title) {
        item.checked = !item.checked;
      }
      return item;
    });
    setSurveyStatus(updatedStatus); // Güncellenmiş statusları state'e set et
  };

  const handleMenuItemClick = (label) => {
    setSelectedLabel(label); // Set selected label for filtering
    setShowSearchBar(true); // Show the search bar
  };
  useEffect(() => {
    // checked olan öğeleri filtrele ve sadece title'larını al
    const selectedTitles = surveyStatus
      .filter((status) => status.checked)
      .map((status) => status.title);

    // Eğer selectedTitles boşsa, tüm title'ları al
    const allTitles = surveyStatus.map((status) => status.title);
    const finalTitles = selectedTitles.length > 0 ? selectedTitles : allTitles;
    setSelectedFilterItems(selectedTitles); // selectedFilterItems array'ini güncelle
    filterSurveys(finalTitles);
  }, [surveyStatus]);
  const filterSurveys = (selectedStatuses) => {
    const filtered = surveys.filter((survey) =>
      selectedStatuses.includes(survey.status)
    );
    setFilteredSurveys(filtered);
  };
  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token.length > 0) {
      if (selectedFunction === "deleteSurvey") {
        deleteSurvey(selectedFunctionParam);
      } else if (selectedFunction === "cloneSurvey") {
        cloneSurvey(selectedFunctionParam);
      } else if (selectedFunction === "getSurveys") {
          getSurveys(selectedFunctionParam);
      }
      setSelectedFunction("");
      setSelectedFunctionParam("");
    }
  }, [token]);

  const handleSearch = () => {
    if (searchTerm !== "") {
      const _items2 = surveys.filter((item) =>
        item.responded.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const _items3 = surveys.filter((item) =>
        item.created_at.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const _items4 = surveys.filter((item) =>
        item.status.toLowerCase().includes(searchTerm.toLowerCase())
      );
      const _items = surveys.filter((item) =>
        item.survey_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSurveys([
        ...new Set([..._items, ..._items2, ..._items3, ..._items4]),
      ]);
    } else {
      setFilteredSurveys(surveys);
    }
  };

  useEffect(() => {
    // setFilteredSurveys(surveys);
    handleSearch();
  }, [surveys]);

  useEffect(() => {
    handleSearch();
  }, [searchTerm]);

  async function getSurveys(new_survey_id) {
    dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", true));
    try {
      const result = await getSurveysFromAPI(token);

      result["surveys"].forEach((survey) => {
        survey["responded"] =
          result["userSurveyItems"].filter(
            (item) => item.survey_id === survey.ID && item.is_completed
          ).length +
          "/" +
          result["userSurveyItems"].filter(
            (item) => item.survey_id === survey.ID
          ).length +
          " Responded";
      });
      dispatch(
        setSurveys(
          result["surveys"].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          )
        )
      );
      if (new_survey_id) {
        dispatch(
          updateTabStates(
            topMenuTabs.activeTab,
            "currentSurvey",
            result["surveys"].find((survey) => survey.ID === new_survey_id)
          )
        );
        dispatch(
          updateTabStates(
            topMenuTabs.activeTab,
            "surveyDetailSelectedTab",
            "Summary"
          )
        );
        dispatch(
          updateTabPath(
            topMenuTabs.activeTab,
            "Summary",
            `/surveys/${new_survey_id}/summary`
          )
        );
        navigate(`/surveys/${new_survey_id}/summary`);
      }
      
    } catch (error) {
      if (error?.message === "Request failed with status code 401") {
        setSelectedFunction("getSurveys");
        setSelectedFunctionParam(new_survey_id);
        checkAuth();
      }

    } finally {
      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
    }
  }

  async function deleteSurvey(survey_id) {
    dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", true));
    try {
      await deleteSurveyFromAPI(token, survey_id)
        .then((result) => {
          dispatch(
            setSurveys(
              surveys
                .filter((survey) => survey.ID !== survey_id)
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            )
          );
          // dispatch(updateTabStates(topMenuTabs.activeTab, 'surveys', surveys.filter((survey) => survey.ID !== survey_id).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))));
          setDeleteAllowMenuOpen(false);
          setDeleteInfoMenuShow(true);
        })
        .catch((error) => {
          if (error.message === "Request failed with status code 401") {
            setSelectedFunction("deleteSurvey");
            setSelectedFunctionParam(survey_id);
            checkAuth();
          }
        });
    } catch (error) {
      
    } finally {
      dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", false));
    }
  }

  async function cloneSurvey(survey) {
    dispatch(updateTabStates(topMenuTabs.activeTab, "pageIsLoading", true));
    try {
      const obj = {
        survey_name: survey.survey_name + "_Copy",
        organization: survey.organization,
        stages: survey.stages ? survey.stages : null,
        content: survey.content,
      };
      await addSurveyFromAPI(token, obj)
        .then((result) => {
          getSurveys(result.survey_id);
          setCloneInfoMenuShow(true);
        })
        .catch((error) => {
          if (error?.message === "Request failed with status code 401") {
            setSelectedFunction("cloneSurvey");
            setSelectedFunctionParam(survey);
            checkAuth();
          } 
        });
    } catch (error) {
    }
  }

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }
  // const searchSurveys = (e) => {
  //   console.log(e.target.value);
  //   const filteredList = surveys.filter((survey) =>
  //     survey["survey_name"].toLowerCase().includes(e.target.value.toLowerCase())
  //   );
  //   setFilteredSurveys(filteredList);
  // };

  const handleSurveySelect = (survey) => {
    if (selectedSurvey !== survey.ID) {
      setSelectedSurvey(survey.ID);
      // dispatch(setCurrentSurvey(survey));
      dispatch(updateTabStates(topMenuTabs.activeTab, "currentSurvey", survey));
      // dispatch(setSurveyDetailSelectedTab("Summary"));
      dispatch(
        updateTabStates(
          topMenuTabs.activeTab,
          "surveyDetailSelectedTab",
          "Summary"
        )
      );
      dispatch(
        updateTabPath(
          topMenuTabs.activeTab,
          "Summary",
          `/surveys/${survey.ID}/summary`
        )
      );
      navigate(`/surveys/${survey.ID}/summary`);
    }
  };

  const surveyActionMenuRef = useRef(null);

  // const handleClickOutside = (event) => {
  //   // Eğer tıklama menü dışında gerçekleştiyse, menüyü kapat
  //   if (
  //     surveyActionMenuRef.current &&
  //     !surveyActionMenuRef.current.contains(event.target)
  //   ) {
  //     setOpenMenu(false);
  //   }
  // };
  const handleClickOutside = (event) => {
    // Tıklanan öğenin childRefs içinde olup olmadığını kontrol et
    const isClickInsideMenu = childRefs.current.some(
      (ref) => ref && ref.contains(event.target)
    );

    if (!isClickInsideMenu) {
      setOpenMenu(null); // Menü kapatılır
    }
  };
  useEffect(() => {
    // Tıklama olayını dinle
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Component unmount olduğunda event listener'ı kaldır
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [positions, setPositions] = useState([]);
  const [scrollEvent, setScrollEvent] = useState(false);
  const parentRefs = useRef([]);
  const childRefs = useRef([]);
  const scrollableContainerRef = useRef(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const handleClick = (index) => {
    const updatedPositions = [...positions];
    const isLastItem = index === filteredSurveys.length - 1;
    const parentRect = parentRefs.current[index]?.getBoundingClientRect();
    updatedPositions[index] = {
      top: parentRect.bottom, // Parent'ın altına 10px ekle
      left: parentRect.left + 10, // Parent'ın soluna 10px ekle
    };

    setPositions(updatedPositions);
  };
  useEffect(() => {
    const handleScroll = () => {
      const updatedPositions = [...positions];
      setScrollEvent(true);
      parentRefs.current.forEach((parentRef, index) => {
        const parentRect = parentRef?.getBoundingClientRect();
        const isLastItem = index === filteredSurveys.length - 1;
        // Konumları güncelle
        updatedPositions[index] = {
          top: isLastItem ? parentRect.bottom - 5 : parentRect.bottom + 10,
          left: parentRect.left + 10,
        };
      });

      setPositions(updatedPositions); // Konumları güncelle
      setOpenMenu(false);
    };

    const scrollableContainer = scrollableContainerRef.current;
    if (scrollableContainer) {
      scrollableContainer.addEventListener("scroll", handleScroll); // Scroll olayını dinle
    }

    // Temizleme işlemi: Scroll dinleyiciyi kaldır
    return () => {
      if (scrollableContainer) {
        setScrollEvent(false);
        scrollableContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [filteredSurveys, positions]);
  useEffect(() => {
    // Automatically close the dialog after 5 seconds
    const timer = setTimeout(() => {
      setCloneInfoMenuShow(false);
      setDeleteInfoMenuShow(false);
    }, 3000); // 5000 ms = 5 seconds

    // Cleanup the timer when the component unmounts or dialog closes
    return () => clearTimeout(timer);
  }, [deleteInfoMenuShow, cloneInfoMenuShow]);

  return (
    <div className="z-1">
      <div className="flex cursor-default items-center justify-between rounded-lg z-1 pt-[0.75rem] pr-[0.75rem] pb-[1.5rem] pl-[1.25rem] space-x-2">
        <span
          className={` whitespace-nowrap break-words text-ellipsis  min-w-0 w-full cursor-default font-bold text-[1.25rem] ${themeMode === "dark" ? "text-white" : "text-[#0F121A]"
            }`}
        >
          Surveys
        </span>
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <MenuButton
              className={`flex items-center self-stretch p-0 pr-1 h-[2rem] min-w-8  rounded-md shadow-inner cursor-pointer border border-[#ffffff17]  ${themeMode === "dark"
                  ? "bg-[#ffffff05] hover:bg-[#ffffff0a]"
                  : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                } `}
            >
              {selectedFilterItems.length !== 0 ? (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedFilterItems([]);
                    setFilteredSurveys(surveys);
                    setSurveyStatus(
                      surveyStatus.map((status) => {
                        status.checked = false;
                        return status;
                      })
                    );
                  }} // Reset search term to empty string

                  className={`flex items-center justify-center gap-3 p-0 px-3 cursor-pointer bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${themeMode === "dark"
                    ? "hover:text-[#fff] text-white"
                    : "hover:text-[#000] text-black-8"
                    }`}
                >
                  <div
                    className={`btn-icon pointer-events-none ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                      }`}
                  >
                    <svg
                      className="svg-small w-[.8rem] h-[.8rem] mr-1"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                    </svg>
                  </div>
                  <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0">
                    Clear filter
                  </span>
                </div>
              ) : (
                <div
                  className={`flex items-center justify-center gap-3 p-0 px-3 cursor-pointer bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${themeMode === "dark"
                    ? "hover:text-[#fff] text-white"
                    : "hover:text-[#000] text-black-8"
                    }`}
                  type="button"
                  onClick={() => {
                    setFilterSearchTerm("");
                    setShowSearchBar(false);
                    togglePopup();
                  }}
                >
                  <div className="pointer-events-none">
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M29.9,4.1c-0.1-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1,0-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.2,0-0.3,0.1C3.5,2.5,3.1,2.7,2.8,3C2.5,3.3,2.3,3.7,2.1,4.1C2,4.5,2,5,2,5.4c0.1,0.4,0.2,0.8,0.5,1.2c0,0,0.1,0.1,0.1,0.1l8.8,9.7v6.9c0,0.3,0.1,0.6,0.4,0.8l7.3,5.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.3-0.2,0.6-0.5,0.6-0.9V16.4l8.8-9.7c0,0,0.1-0.1,0.1-0.1c0.2-0.4,0.4-0.8,0.5-1.2C30,5,30,4.5,29.9,4.1z M27.9,5.4l-9,9.9c-0.2,0.2-0.3,0.4-0.3,0.7v10.7l-5.3-3.9V16c0-0.2-0.1-0.5-0.3-0.7l-9-9.9C4.1,5.3,4,5.2,4,5.1C4,5,4,4.9,4,4.8c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1h23.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3C28,4.9,28,5,28,5.1C28,5.2,27.9,5.3,27.9,5.4z"></path>
                    </svg>
                  </div>
                  <span className="overflow-hidden text-ellipsis whitespace-nowrap ">
                    Filter
                  </span>
                </div>
              )}
            </MenuButton>
          </div>

          <MenuItems
            transition
            className={`absolute right-30 z-10 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${themeMode === "dark"
                ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
          >
            <div className="py-1">
              <div className="px-1 py-2">
                <input
                  type="text"
                  placeholder="Search..."
                  value={filterSearchTerm}
                  onChange={(e) => setFilterSearchTerm(e.target.value)}
                  className={`w-full px-2 py-1 mb-2 rounded-md  ${themeMode === "dark"
                      ? " bg-[#2a2939]  shadow-theme-popup-shadow  placeholder:text-white text-white"
                      : "bg-[#FFFFFF] shadow-black-2-shadow placeholder:text-black text-black"
                    }`}
                />
                <div className="flex-grow min-h-0 h-max overflow-x-hidden overflow-y-auto">
                  <div className="flex flex-col h-full">
                    {surveyStatus
                      .filter(
                        (status) =>
                          !filterSearchTerm.trim() || // Eğer arama terimi boşsa tüm öğeleri döndür
                          status.title
                            .toLowerCase()
                            .includes(filterSearchTerm.toLowerCase())
                      )
                      .map((status, index) => (
                        <button
                          key={index}
                          onClick={() => handleStatusClick(status)}
                          className={`mx-2 cursor-pointer flex-shrink-0 justify-start p-1 px-2 min-w-0 min-h-[2.25rem] text-left ${themeMode === "dark"
                              ? "text-white bg-[2a2939] hover:bg-[#333240]"
                              : "text-black bg-[#FFFFFF] hover:bg-[#EBEBEB]"
                            } rounded`}
                        >
                          <div className="flex justify-between items-center min-w-0 min-h-0 w-full">
                            <div className="flex items-center justify-between flex-nowrap min-w-0 min-h-0 w-full">
                              <div
                                className={`flex items-center ${themeMode === "dark"
                                    ? "text-white"
                                    : "text-black"
                                  } flex-wrap-nowrap min-w-0 cursor-pointer`}
                              >
                                <div className="">{status.icon}</div>
                                <span className="ml-2 whitespace-nowrap break-words truncate overflow-hidden min-w-0 ">
                                  {status.title}
                                </span>
                              </div>
                              {status.checked && (
                                <div className="pointer-events-none">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="w-4 h-4"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m4.5 12.75 6 6 9-13.5"
                                    />
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>
                        </button>
                      ))}
                  </div>
                </div>
              </div>

            </div>
          </MenuItems>
        </Menu>
      </div>

      <div
        className={`flex items-center h-[2rem] border rounded-lg pl-2 pr-3 mx-[0.75rem] py-2 focus-within:ring-1 focus-within:ring-blue-500
                                    ${themeMode === "dark"
            ? "border-[#ffffff17] bg-[#ffffff05]"
            : "border-[#00000017] bg-[#00000005]"
          }
                                    `}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1"
          stroke={themeMode === "dark" ? "#ffffffcc" : "black"}
          className="size-[18px] hover:stroke-white"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
          />
        </svg>
        <input
          type="text"
          placeholder="Search"
          className={`w-full focus:outline-none bg-transparent ${themeMode === "dark" ? "text-white" : "text-black"
            } px-2`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div
        className={`h-px mt-4 mb-0 ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
          }`}
      ></div>

      <div className="flex flex-col max-h-[calc(100vh-200px)] z-1">
        <ul
          ref={scrollableContainerRef}
          className={`px-3 py-2 space-y-2 gap-1  flex flex-col flex-grow overflow-y-scroll  overflow-anchor-none max-h-full scrollable-container ${themeMode === "dark" ? "border-[#ffffff17]" : "border-[#00000017]"
            }`}
        >
          {filteredSurveys.map((survey, index) => (
            <li
              key={survey.ID}
              className=" flex flex-col min-h-[2rem] my-0 py-0 group "
              onClick={() => {
                if(window.innerWidth<1024 && expanded){
                  getLeftMenuExpandActionFromChild(false)
                }
                ;handleSurveySelect(survey)}}
            >
              <div
                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark" ? "text-white  " : "text-gray-500  "
                  } `}
              >
                <div className="flex items-center">
                  {survey.status === "Draft" && (
                    <svg
                      className="size-5 mt-[0.47rem]"
                      fill="#A1A1A1"
                      strokeWidth="1"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
                      ></path>
                    </svg>
                  )}
                  {survey.status === "In Progress" && (
                    <svg
                      className="size-5 mt-[0.47rem]"
                      fill="#5195D7"
                      strokeWidth="1"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                      ></path>
                      <path
                        d="M 4.5 4.5 L 9 4.5 A 4.5 4.5 0 1 1 0.00022499812500598182 4.54499925000375 Z"
                        transform="translate(3.5,3.5)"
                      ></path>
                    </svg>
                  )}
                  {survey.status === "Completed" && (
                    <svg
                      className="size-5 mt-[0.47rem]"
                      fill="#83AF12"
                      strokeWidth="1"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C15,4.1,11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path>
                      <path d="M10.6,6.1L7.5,9.2L5.9,7.6c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l2,2c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l3.5-3.5c0.2-0.2,0.2-0.6,0-0.8S10.8,5.8,10.6,6.1z"></path>
                    </svg>
                  )}
                  <span
                    className={` whitespace-wrap break-words text-ellipsis line-clamp-1 min-w-0 ${themeMode === "dark" ? "text-white" : "text-[#0F121A]"
                      } ${selectedSurvey === survey.ID
                        ? "text-black"
                        : "focus:ring-2 focus:ring-blue-500 "
                      }`}
                    title={survey.survey_name}
                  >
                    {survey.survey_name}
                  </span>
                </div>
                <div
                  ref={(el) => (parentRefs.current[index] = el)}
                  className="hidden group-hover:block hover:bg-[#a5bdff0d] hover:rounded-[3px] hover:p-[2px]  "
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering survey select
                    setOpenMenu(openMenu === index ? null : index);
                    handleClick(index);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                    />
                  </svg>
                </div>
              </div>
              {openMenu === index && (
                <div
                  ref={(el) => (childRefs.current[index] = el)}
                  // ref={surveyActionMenuRef}
                  className=" fixed  overflow-visible ml-2 rounded origin-center box-border z-[10]"
                  style={{
                    [scrollEvent ? "bottom" : "top"]: positions[index]
                      ? `${positions[index].top}px`
                      : "-9999px", // İlk başta görünmemeli
                    left: positions[index]
                      ? `${positions[index].left}px`
                      : "-9999px",
                  }}
                >
                  <div
                    className={`flex flex-col w-[120px] border border-solid rounded-lg shadow-theme-popup-shadow select-none ${themeMode === "dark"
                        ? "bg-theme-popup-color border-theme-popup-divider"
                        : "bg-[#FFFFFF] border-black-09"
                      }`}
                  >
                    <ul className="px-2 py-2">
                      <li
                        className={`px-2 py-[.225rem] rounded cursor-pointer flex items-center space-x-0 ${themeMode === "dark"
                            ? " border-theme-popup-divider  hover:bg-[#333240]"
                            : " border-black-09  hover:bg-[#EBEBEB]"
                          }`}
                      >
                        <div>
                          <button
                            className="group  flex w-full justify-center items-center rounded-lg hover:text-gray-700"
                            onClick={(e) => {
                              e.stopPropagation();
                              cloneSurvey(survey);
                            }}
                          >
                            <div
                              className={`${themeMode === "dark"
                                  ? "text-whiteTransparent"
                                  : "text-black-06"
                                }`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke={
                                  themeMode === "dark"
                                    ? "currentColor"
                                    : "black"
                                }
                                strokeWidth="2"
                                className="size-5 hover:bg-[#b3b1b112] rounded p-1 cursor-pointer"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
                                />
                              </svg>
                            </div>
                            <span
                              className={` px-2 py-1.5  pr-4 text-sm  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0 pr-4 flex-grow  ${themeMode === "dark"
                                  ? "text-[#FFF]"
                                  : "text-[#000]"
                                }`}
                            >
                              Clone
                            </span>
                          </button>
                        </div>
                      </li>
                      <li
                        className={`px-2 py-[.225rem] rounded cursor-pointer flex items-center space-x-0 ${themeMode === "dark"
                            ? "hover:bg-[#333240]"
                            : " hover:bg-[#EBEBEB]"
                          }`}
                      >
                        {/* <form> */}
                        <button
                          type="submit"
                          className="group relative flex w-full justify-center items-center rounded-lg text-sm text-gray-500  hover:text-gray-700"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSurveyId(survey.ID);
                            setDeleteAllowMenuOpen(true);
                          }}
                        >
                          <div
                            className={`${themeMode === "dark"
                                ? "text-whiteTransparent"
                                : "text-black-06"
                              }`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke={
                                themeMode === "dark" ? "currentColor" : "black"
                              }
                              strokeWidth="2"
                              className="size-5 hover:bg-[#b3b1b112] rounded p-1 cursor-pointer"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                              />
                            </svg>
                          </div>
                          <span
                            className={` px-2 py-1.5  pr-4 text-sm  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0 pr-4 flex-grow  ${themeMode === "dark"
                                ? "text-[#FFF]"
                                : "text-[#000]"
                              }`}
                          >
                            Delete
                          </span>
                        </button>
                        {/* </form> */}
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div
        className={`h-px  ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
          }`}
      ></div>
      <Dialog
        open={deleteAllowMenuOpen}
        onClose={setDeleteAllowMenuOpen}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    Delete Selected Survey
                  </DialogTitle>
                  <div className="mt-1">
                    <p
                      className={`text-sm ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                        }`}
                    >
                      Are you sure you want to delete this survey
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={(e) => {
                    deleteSurvey(selectedSurveyId);
                  }}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setDeleteAllowMenuOpen(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${themeMode === "dark"
                      ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                      : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                >
                  No
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={deleteInfoMenuShow}
        onClose={setDeleteInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full w-1/6 items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        fill="#008000"
                        stroke="#fff"
                      />
                    </svg>
                    Survey deleted
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setDeleteInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={cloneInfoMenuShow}
        onClose={setCloneInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full w-1/6 items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        fill="#008000"
                        stroke="#fff"
                      />
                    </svg>
                    Survey Cloned
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setCloneInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
